// src/services/PresidenteDashboardService.js

import api from './api';
import defesaService from './defesaService';
import avaliacaoService from './avaliacaoService';

/**
 * Busca os dados do Presidente (monografias, defesas do avaliador, avaliações).
 */
const getDadosPresidente = async () => {
  try {
    // Podemos usar Promise.all para buscar tudo em paralelo
    const [
      monografiasResponse,
      defesasResponse,
      avaliacoesResponse
    ] = await Promise.all([
      // Monografias (se quiser filtrar, troque aqui)
      api.get('/monografias'), 
      
      // Defesas específicas do presidente
      defesaService.listarDefesasDoAvaliador(),
      
      // Avaliações (todas ou filtrar se desejar)
      avaliacaoService.listarAvaliacoes()
    ]);

    return {
      monografias: monografiasResponse.data,
      defesas: defesasResponse.data, // Somente as do presidente
      avaliacoes: avaliacoesResponse.data
    };
  } catch (error) {
    console.error('Erro em getDadosPresidente:', error);
    throw error;
  }
};

const PresidenteDashboardService = {
  getDadosPresidente
};

export default PresidenteDashboardService;
